import { GetPointEligibleProgramsForListingsEndpoint } from '@kouto/types';
import { z } from 'zod';
import useSWR from 'swr';
import { BASE_URL } from 'consts';
import getEligibleProgram from './getEligibleProgram';

export type GetEligibleProgramResponse = {
  [listingId: string]: {
    org: string;
    payEligible: boolean;
    earnEligible: boolean;
  } | null;
};

export type GetEligibleProgramRequest = z.infer<
  typeof GetPointEligibleProgramsForListingsEndpoint.requestSchema
>;

const useGetEligibleProgram = (
  brandId?: string | null,
  requestBody?: GetEligibleProgramRequest | null,
) => {
  const swr = useSWR<GetEligibleProgramResponse>(
    brandId && requestBody ? [brandId, requestBody] : null,
    async ([brandId, body]) => {
      const response = await getEligibleProgram(
        `${BASE_URL}/v1/loyalty/listings/eligible`,
        { brandId },
        body as GetEligibleProgramRequest,
      );
      return response as unknown as GetEligibleProgramResponse;
    },
  );

  if (swr.error) {
    console.error('Error fetching eligible programs:', swr.error);
  }

  return { ...swr };
};

export default useGetEligibleProgram;
